export const count = (value: number): string => new Intl.NumberFormat().format(value);
export const percent = (value: number | null): string => value === null ? '—' : `${value.toFixed(1)}%`;
export const money = (value: string | number | null, currency: string | null): string =>
  value === null || !currency ? '—' : new Intl.NumberFormat(undefined, { style: 'currency', currency, currencyDisplay: 'narrowSymbol', minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(Number(value));
export function relativeChange(current: number, previous: number): number | null {
  return previous > 0 ? (current - previous) / previous * 100 : null;
}
